import { render, staticRenderFns } from "./SeniorManagement.vue?vue&type=template&id=92f3e57e&scoped=true&"
import script from "./SeniorManagement.vue?vue&type=script&lang=js&"
export * from "./SeniorManagement.vue?vue&type=script&lang=js&"
import style0 from "./SeniorManagement.vue?vue&type=style&index=0&id=92f3e57e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f3e57e",
  null
  
)

export default component.exports